<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 33.333333%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
</style>

<template>
  <div>
    <div class="d-flex justify-content-between" style="margin-bottom: 10px">
      <div>
        <p style="font-size: 12px">
          <b-icon icon="info" variant="success"></b-icon>&nbsp;Select table row
          for more option.
        </p>
      </div>
      <b-button-group v-if="editableOps">
        <b-button
          v-b-modal.modal-form-coring-sidewell-desc
          variant="outline-primary"
          size="sm"
          @click="popUpForm('ADD')"
          >Add</b-button
        >
        <b-button
          v-if="selectedRow.length > 0"
          v-b-modal.modal-form-coring-sidewell-desc
          variant="outline-primary"
          size="sm"
          @click="popUpForm('UPDATE')"
          >Update</b-button
        >
        <b-button
          v-if="selectedRow.length > 0"
          v-b-modal.modal-remove-coring-sw-desc
          variant="outline-primary"
          size="sm"
          >Delete</b-button
        >
        <b-button
          variant="outline-primary"
          size="sm"
          @click="refreshTableAndCombo"
          >Refresh</b-button
        >
      </b-button-group>
    </div>
    <DxDataGrid
      id="coring-sidewall-grid"
      :data-source="listItem"
      :show-borders="false"
      :show-column-lines="false"
      :show-row-lines="true"
      column-resize-mode="nextColumn"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :cell-hint-enabled="true"
      :word-wrap-enabled="true"
      :column-auto-width="false"
      :column-width="100"
      :height="300"
    >
      <DxPaging :enabled="false"/>
      <DxSelection mode="single"/>
      <DxScrolling column-rendering-mode="virtual"/>
      <DxEditing
          :allow-updating="true"
          :allow-adding="true"
          :allow-deleting="true"
          :use-icons="true"
          mode="row"/>
      <DxColumn v-for="column in tableFields" :key="column.key" :data-field="column.key" :caption="column.label" :data-type="column.type" />
    </DxDataGrid>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxEditing,
  DxFormItem,
  DxLookup,
  DxSelection,
  DxScrolling
} from 'devextreme-vue/data-grid'
import notify from "devextreme/ui/notify"
import { formMethods } from '@state/helpers'

export default {
  components: { 
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing,
    DxSelection,
    DxScrolling,
    // DxFormItem,
    DxLookup,
    // DxForm,
    // DxSimpleItem,
    // DxGroupItem,
  },
  props: {
    submitId: {
      type: Number,
      default: undefined,
    },
    editableOps: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selectedRow: [],
      listItem: [],
      perPage: 10,
      tableBusy: false,
      currentPage: 1,
      coringSidewallIsLoading: false,
      tableFields: [
        { key: 'intervalNo', label: 'Interval No', type: 'number' },
        { key: 'coreDate', label: 'Core Date', type: 'date' },
        { key: 'mdTop', label: 'MD Top', type: 'number' },
        { key: 'mdBase', label: 'MD Base', type: 'number' },
        { key: 'intervalLength', label: 'Interval Length', type: 'number'},
        { key: 'bulkDensity', label: 'Bulk Density', type: 'number'},
      ],
      selectedAction: '',
      form: [],
      currIntervalNo: 1,
      show: false,
    }
  },

  computed: {
    totalRows: function () {
      return this.listItem.length
    },
  },

  watch: {
    submitId: function (val) {
      this.refreshTableAndCombo()
    },
  },

  created: function () {
    this.refreshTableAndCombo()
  },

  methods: {
    ...formMethods,
    refreshTableAndCombo() {
      this.listItem = []
      if (this.submitId) {
        this.tableBusy = true
        this.getActivityCoringSidewallDesc({
          params: { submitId: this.submitId },
        }).then((resp) => {
          this.listItem = resp.data.data
          this.tableBusy = false
          if (this.listItem.length > 0) {
            this.listItem.forEach((item) => {
              if (item.intervalNo >= this.currIntervalNo) {
                this.currIntervalNo = item.intervalNo + 1
              }
            })
          } else {
            this.currIntervalNo = 1
          }
        })
      } else {
        console.log('No report selected')
      }
      this.loadAllCombo()
    },
    loadAllCombo() {},
    onRowSelected(item) {
      if (item.length === 0) {
        this.selectedRow = []
        this.$refs.tableDataCoringSWDesc.clearSelected()
        return
      }
      this.selectedRow = item
      this.form = item[0]
    },
    makeToast(msg) {
      this.$bvToast.toast(msg, {
        title: 'Notification',
        autoHideDelay: 5000,
        appendToast: false,
      })
    },
    saving(e) {
      let rowData = {}
      if (Array.isArray(e.changes)) {
        rowData = {...e.changes[0].data}        
      } else {
        rowData = {...e.changes.data}
      }
      delete rowData.intId
      rowData.submitId = this.submitId
      this.addActivityCoringSidewallDesc({ params: rowData }).then((resp) => {
          this.retrieveDataTable()
          notify({ message: 'Data has been recorded.', width: 300 }, 'success', 5000)
      })
    },
    askServerToRemoveData() {
      if (this.selectedRow.length > 0) {
        const data = { ...this.selectedRow[0] } // removeActivityCoringSidewallDesc
        this.removeActivityCoringSidewallDesc({ params: data }).then((resp) => {
          this.refreshTableAndCombo()
          this.closeModalRemove()
          this.makeToast(
            'Remove data sidewall coring description details success.'
          )
        })
      }
    },
    calculateIntervalLength() {
      // this.$nextTick((val) => {

      // })

      if (this.form.mdBase === undefined || this.form.mdTop === undefined) {
        this.form.intervalLength = 0
      } else {
        this.form.intervalLength =
          (this.form.mdBase === undefined ? 0 : this.form.mdBase) -
          (this.form.mdTop === undefined ? 0 : this.form.mdTop)
      }
    },
  },
}
</script>